import { render, staticRenderFns } from "./createsmspackage.vue?vue&type=template&id=7145bd6d&"
import script from "./createsmspackage.vue?vue&type=script&lang=ts&"
export * from "./createsmspackage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createsmspackage.vue"
export default component.exports